/* QUELL — "In This Range" PDP carousel: prev/next arrows scroll the track. */
(function () {
  if (window.__prCarousel) return;
  window.__prCarousel = true;

  function init(track) {
    if (track.__prBound) return;
    track.__prBound = true;

    var head = track.closest(".pr-range");
    var prev = head && head.querySelector("[data-pr-prev]");
    var next = head && head.querySelector("[data-pr-next]");

    function stepSize() {
      var card = track.querySelector(".card");
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 18;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev)
      prev.addEventListener("click", function () {
        track.scrollBy({ left: -stepSize(), behavior: "smooth" });
      });
    if (next)
      next.addEventListener("click", function () {
        track.scrollBy({ left: stepSize(), behavior: "smooth" });
      });

    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function boot(scope) {
    (scope || document)
      .querySelectorAll("[data-range-carousel]")
      .forEach(init);
  }

  if (document.readyState !== "loading") boot();
  else
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
})();
